import * as React from 'react';
export const IcBusinessman = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M8.81 9.7c.55.55 1.23.94 1.97 1.15a4.5 4.5 0 002.36.02c.77-.2 1.48-.61 2.05-1.17.57-.57.97-1.27 1.17-2.05.2-.77.2-1.59-.02-2.36-.2-.75-.6-1.43-1.15-1.97-.55-.55-1.23-.94-1.97-1.15a4.5 4.5 0 00-2.36-.02c-.77.2-1.48.61-2.05 1.17-.57.56-.97 1.27-1.17 2.05-.2.77-.2 1.59.02 2.36.2.75.6 1.43 1.15 1.97zM15.7 12.91L13.24 18l-.73-3.84C14.16 12 12.35 12 12 12c-.38 0-2.16 0-.51 2.16L10.76 18 8.3 12.91A7.993 7.993 0 004 20v.03C4 21.12 4.88 22 5.97 22h12.06c1.09 0 1.97-.88 1.97-1.97V20a8 8 0 00-4.3-7.09z'
      fill='currentColor'
    />
  </svg>
);
